export var updateSource = function updateSource(authUrl) {
  var url = new URL(authUrl);
  if (true) url.searchParams.set('source', window.location.href);
  return url.toString();
};